const state = {
	balance: 120
}

// getters
const getters = {}

// actions
const actions = {
	changeBalance({commit}, amount) {
		commit('changeBalance', amount)
	},
}

// mutations
const mutations = {
	changeBalance(state, amount) {
		state.balance += Number(amount)
	}
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}
